<template>
  <div>
    <NavbarAdminPlus v-if="$store.state.adminPlusVersion" v-bind="$props" v-on="$listeners" />
    <NavbarLegacy v-else v-bind="$props" v-on="$listeners" />
  </div>
</template>

<script>
import NavbarLegacy from "./NavbarLegacy.vue";
import NavbarAdminPlus from "./NavbarAdminPlus.vue";

export default {
  name: "NavigationNavbar",
  components: {
    NavbarLegacy,
    NavbarAdminPlus,
  },
  props: {
    minimizedDrawer: {
      type: Boolean,
      default: true,
    },
    quickSearchQuery: {
      type: String,
      default: null,
    },
    loadingQuickSearch: {
      type: Boolean,
      default: false,
    },
    filteredQuickSearchItems: {
      type: Array,
      default: () => [],
    },
    paymentsReady: {
      type: Boolean,
      default: false,
    },
    darkTheme: {
      type: Boolean,
      default: false,
    },
    appVersion: {
      type: String,
      default: null,
    },
    stripeAccountId: {
      type: String,
      default: null,
    },
  },
};
</script>
